import { render, staticRenderFns } from "./KerstmisOrnament.vue?vue&type=template&id=5c5ff25e&"
import script from "./KerstmisOrnament.vue?vue&type=script&lang=js&"
export * from "./KerstmisOrnament.vue?vue&type=script&lang=js&"
import style0 from "./KerstmisOrnament.vue?vue&type=style&index=0&id=5c5ff25e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports